//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    SYNC_CTC_INFORMATION_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    syncCTCInformationResult,
} from 'Redux/actions';


function* importCalampFromCTC({ payload }) {
    try {
        let QUERY = `
            mutation importCalampFromCTC {
                result: importCalampFromCTC {
                    stepFunctionId
                    processStartDate
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {},
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(syncCTCInformationResult(data?.result))
        } else {
            yield put(syncCTCInformationResult({ stepFunctionId: true }))
        }

    } catch (exc) {
        yield put(syncCTCInformationResult({ error: true }))
        ExceptionManager(exc, 'Modules/manufacturers/views/.components/syncCTCInformation/redux/saga', 'importCalampFromCTC');
    }
}

function* watchManufacturerRequests() {
    yield takeEvery(SYNC_CTC_INFORMATION_REQUEST, importCalampFromCTC);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchManufacturerRequests)
    ]);
}